import React from 'react'
import PropTypes from 'prop-types'

function RankTooltip({ userLevel = '' }) {
  return (
    <section className="tooltip-rating__section tooltip-rating__section--borderless">
      <h4 className="heading-16">Level: {userLevel}</h4>
    </section>
  )
}

RankTooltip.propTypes = {
  userLevel: PropTypes.string,
}

export default RankTooltip
